import { createBrowserHistory } from 'history';

// Navigation manager, e.g. history.push('/home')
// https://github.com/mjackson/history
export default process.env.BROWSER ? createBrowserHistory() : undefined;
// export default createBrowserHistory();